var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-wrapper"},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"src":require("@/assets/error/404.png"),"alt":""}}),_c('div',{staticClass:"back-to-login",on:{"click":_vm.backToIndex}},[_vm._v("返回首页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }